module.exports = __webpack_public_path__ + "static/media/partners-image-9.df3ff220.png";